export default "__VITE_ASSET__Be3o7Aty__"